import currencyJs from "currency.js";
import { formatDistanceStrict } from "date-fns";
/**
 * GET THE DIFFERENCE DATE FORMAT
 * @param  DATE | NUMBER | STRING
 * @returns FORMATTED DATE STRING
 */

function getDateDifference(date) {
  const distance = formatDistanceStrict(new Date(), new Date(date));
  return distance + " ago";
}
/**
 * RENDER THE PRODUCT PAGINATION INFO
 * @param page - CURRENT PAGE NUMBER
 * @param perPageProduct - PER PAGE PRODUCT LIST
 * @param totalProduct - TOTAL PRODUCT NUMBER
 * @returns
 */


function renderProductCount(page, perPageProduct, totalProduct) {
  let startNumber = (page - 1) * perPageProduct;
  let endNumber = page * perPageProduct;

  if (endNumber > totalProduct) {
    endNumber = totalProduct;
  }

  return `Showing ${startNumber - 1}-${endNumber} of ${totalProduct} products`;
}
/**
 * CALCULATE PRICE WITH PRODUCT DISCOUNT THEN RETURN NEW PRODUCT PRICES
 * @param  price - PRODUCT PRICE
 * @param  discount - DISCOUNT PERCENT
 * @returns - RETURN NEW PRICE
 */


function calculateDiscount(price, discount) {
  const afterDiscount = Number((price - price * (discount / 100)).toFixed(2));
  return currency(afterDiscount);
}
/**
 * CHANGE THE CURRENCY FORMAT
 * @param  price - PRODUCT PRICE
 * @param  fraction - HOW MANY FRACTION WANT TO SHOW
 * @returns - RETURN PRICE WITH CURRENCY
 */


function currency(price, fraction = 2) {
  const formatCurrency = currencyJs(price).format({
    precision: fraction,
    symbol: 'RM',
  });
  return formatCurrency;
}


function convertTZ(date, tzString) {
    return new Date((typeof date === "string" ? new Date(date) : date).toLocaleString("en-US", {timeZone: tzString}));
}

const generateStatus = (statusKey, isPickup = false) => {
    switch (statusKey) {
        case 'pending-approval':
            return "Pending approval";
        case 'pending-payment':
            return "Pending payment";
        case 'pending-shipment':
            return isPickup ? "Pending Packing" : "Pending shipment";
        case 'pending-pickup':
            return "Pending pickup";
        case 'pending-delivery':
            return "Pending delivery";
        case 'completed':
            return "Completed";
        case 'refund-request':
            return "Refund requested";
        case 'refund-approved':
            return "Refund approved";
        case 'refund-cancelled':
            return "Refund cancelled";
        case 'refunded':
            return "Refunded";
        case 'rejected':
            return "Rejected";
        case 'cancelled':
            return "Cancelled";
    }
}

const getColor = status => {
    switch (status) {
        case "pending-approval":
            return "primary";
        case "pending-payment":
            return "primary";

        case "pending-shipment":
            return "secondary";

        case "pending-delivery":
            return "secondary";

        case "completed":
            return "success";

        case "Cancelled":
            return "primary";

        case "cancelled":
            return "error";

        case "rejected":
            return "error";

        default:
            return "default";
    }
};

const checkAddedQuantity = (products, cart, categoryId) => {
    let totalQuantity = 0;
    cart.forEach(item => {
        const product = products.find(product => product.product.id === item.id);
        // Check both string and number versions of categoryId to handle type mismatches
        if (product?.product?.categories.includes(categoryId) || 
            product?.product?.categories.includes(String(categoryId))) {
            totalQuantity += item.qty;
        }
    });
    return totalQuantity;
}

function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

const generateProductProperties = (variant) => {
    let text = '';
    let count = 0
    for (const type in variant) {
        const value = variant[type];
        text += capitalizeFirstLetter(type) + ': ' + value;
        count++;
        if (Object.keys(variant).length !== count) text += ', ';
    }
    return text;
}

/**
 * Compare two variant option values.
 *
 * A product declares its options in productVariants ("KAF-13") while each
 * variant row stores the chosen value in variantObject ("Kaf-13"). Nothing
 * forces those to agree on case, and when they disagreed a strict comparison
 * silently dropped the option: the group heading rendered with no values under
 * it, and the size simply could not be bought. Casing is a typing accident,
 * never a distinction the customer means to draw.
 */
const sameVariantValue = (a, b) =>
    String(a ?? '').trim().toLowerCase() === String(b ?? '').trim().toLowerCase();

const getVariant = (selectedVariant = {}, variants) => variants.filter(variant => Object.keys(selectedVariant).every((key) => sameVariantValue(selectedVariant[key], variant['variantObject'][key])))?.[0];

const states = [
    { key: "jhr", label: "Johor" },
    { key: "kdh", label: "Kedah" },
    { key: "ktn", label: "Kelantan" },
    { key: "mlk", label: "Melaka" },
    { key: "nsn", label: "Negeri Sembilan" },
    { key: "phg", label: "Pahang" },
    { key: "prk", label: "Perak" },
    { key: "pls", label: "Perlis" },
    { key: "png", label: "Pulau Pinang" },
    { key: "sgr", label: "Selangor" },
    { key: "trg", label: "Terengganu" },
    { key: "kul", label: "Kuala Lumpur" },
    { key: "pjy", label: "Putrajaya" },
    { key: "srw", label: "Sarawak" },
    { key: "sbh", label: "Sabah" },
    { key: "lbn", label: "Labuan" }
];
const getStateLabel = (key) => {
    const state = states.find(state => state.key === key);
    return state ? state.label : null;
}

const couriersList = [
    {
        name: "J&T Express",
        cid: "85",
        logo: "https://s3-ap-southeast-1.amazonaws.com/easyparcel-static/Public/source/general/img/couriers/J&T_Express.jpg",
    },
    {
        name: "Skynet",
        cid: "6",
        logo: "https://s3-ap-southeast-1.amazonaws.com/easyparcel-static/Public/source/general/img/couriers/Skynet.jpg",
    },
    {
        name: "Flash Express",
        cid: "90",
        logo: "https://s3-ap-southeast-1.amazonaws.com/easyparcel-static/Public/source/general/img/couriers/Flash_Express.jpg",
    },
    {
        name: "LineClear Express",
        cid: "1001",
        logo: "https://s3-ap-southeast-1.amazonaws.com/easyparcel-static/Public/source/general/img/couriers/LineClear_Express.jpg",
    },
    {
        name: "City-Link Express",
        cid: "1000",
        logo: "https://s3-ap-southeast-1.amazonaws.com/easyparcel-static/Public/source/general/img/couriers/City-Link_Express.jpg",
    },
    {
        name: "Aramex",
        cid: "23",
        logo: "https://s3-ap-southeast-1.amazonaws.com/easyparcel-static/Public/source/general/img/couriers/Aramex.jpg",
    },
    {
        name: "DHL eCommerce",
        cid: "22",
        logo: "https://s3-ap-southeast-1.amazonaws.com/easyparcel-static/Public/source/general/img/couriers/DHLeC.jpg",
    },
    {
        name: "Ninjavan",
        cid: "93",
        logo: "https://s3-ap-southeast-1.amazonaws.com/easyparcel-static/Public/source/general/img/couriers/Ninjavan.jpg",
    },
]

const getCSRItems = (csr_order) => {
    if (!csr_order || !csr_order.project) {
        return [];
    }

    const { packages } = csr_order.project;
    const { package_type, school_type, gender } = csr_order.project_info || {};

    if (!packages || !Array.isArray(packages)) {
        return [];
    }

    // If no specific package/school/gender filter is set, return all products from all packages
    if (!package_type || !school_type || !gender) {
        let allProducts = [];
        packages.forEach(pkg => {
            if (pkg && pkg.products && Array.isArray(pkg.products)) {
                allProducts = allProducts.concat(pkg.products);
            }
        });
        return allProducts;
    }

    // First find the matching package
    const matchingPackage = packages.find(p =>
        p && p.packageName === package_type && p.school_type === school_type
    );

    if (!matchingPackage || !matchingPackage.products) {
        return [];
    }

    // Then filter the products by gender
    return matchingPackage.products.filter(p =>
        p && p.gender &&
        (p.gender.toLowerCase() === gender.toLowerCase() ||
            p.gender.toLowerCase() === 'unisex')
    );
};

const prettifyIssueType = (issueType) => {
    const issueTypeMap = {
        'refund': 'Refund',
        'general': 'General',
        'problem': 'Problem',
        'withdrawal': 'Withdrawal',
        'vendor-refund-request': 'Vendor Refund Request',
        'finance-refund': 'Finance Refund Processing'
    };
    
    return issueTypeMap[issueType] || issueType.split('-').map(word => 
        word.charAt(0).toUpperCase() + word.slice(1)
    ).join(' ');
};

export { getCSRItems, currency, getDateDifference, calculateDiscount, renderProductCount, convertTZ, generateStatus, getColor, checkAddedQuantity, capitalizeFirstLetter, generateProductProperties, getVariant, sameVariantValue, states, getStateLabel, couriersList, prettifyIssueType };
